'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Mail = function (_React$PureComponent) {
  _inherits(Mail, _React$PureComponent);

  function Mail() {
    _classCallCheck(this, Mail);

    return _possibleConstructorReturn(this, (Mail.__proto__ || Object.getPrototypeOf(Mail)).apply(this, arguments));
  }

  _createClass(Mail, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          width: this.props.size,
          height: this.props.size,
          viewBox: '0 0 128 128'
        },
        _react2.default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd', transform: 'translate(20 13)' },
          _react2.default.createElement('path', {
            fill: '#231F20',
            d: 'M7.088 35.833C3.927 38.156 0 41.748 0 46.093v48.752c0 4.334 3.173 7.854 7.088 7.854H81.04c3.915 0 7.088-3.52 7.088-7.854V46.094c0-4.334-3.951-7.902-7.088-10.249-6.896-5.172-26.22-19.563-33.834-25.225a5.244 5.244 0 0 0-6.273 0c-7.531 5.639-26.567 19.826-33.846 25.213z',
            opacity: '.15'
          }),
          _react2.default.createElement('path', {
            fill: '#00B1A2',
            d: 'M7.088 31.044C3.927 33.367 0 36.96 0 41.293v48.752c0 4.334 3.173 7.853 7.088 7.853H81.04c3.915 0 7.088-3.52 7.088-7.853V41.293c0-4.334-3.951-7.902-7.088-10.249A22779.04 22779.04 0 0 0 47.207 5.831a5.244 5.244 0 0 0-6.273 0C33.403 11.47 14.367 25.657 7.088 31.044z'
          }),
          _react2.default.createElement('path', {
            fill: '#00B1A2',
            d: 'M7.088 26.256C3.927 28.578 0 32.17 0 36.504v48.752c0 4.334 3.173 7.853 7.088 7.853H81.04c3.915 0 7.088-3.52 7.088-7.853V36.504c0-4.334-3.951-7.902-7.088-10.248-6.896-5.173-26.22-19.551-33.834-25.214a5.244 5.244 0 0 0-6.273 0C33.403 6.669 14.367 20.868 7.088 26.256z'
          }),
          _react2.default.createElement('rect', {
            width: '59.431',
            height: '61.251',
            x: '14.343',
            y: '12.332',
            fill: '#C1C1C1',
            fillRule: 'nonzero',
            rx: '5.97'
          }),
          _react2.default.createElement('rect', {
            width: '59.431',
            height: '61.251',
            x: '14.343',
            y: '9.937',
            fill: '#F2F2F2',
            fillRule: 'nonzero',
            rx: '5.97'
          }),
          _react2.default.createElement('path', {
            fill: '#878E91',
            d: 'M43.029 26.986h-15.9a2.197 2.197 0 1 1 0-4.394h15.9a2.197 2.197 0 0 1 0 4.394M61 37.773H27.13a2.197 2.197 0 0 1 0-4.394H61a2.197 2.197 0 1 1 0 4.394M61 48.548H27.13a2.197 2.197 0 1 1 0-4.394H61a2.197 2.197 0 1 1 0 4.394M61 59.335H27.13a2.197 2.197 0 1 1 0-4.394H61a2.197 2.197 0 1 1 0 4.394'
          }),
          _react2.default.createElement('path', {
            fill: '#50D8BE',
            d: 'M7.088 35.917C3.927 33.62 0 32.17 0 36.504v48.752c0 4.334 3.173 7.853 7.088 7.853H81.04c3.915 0 7.088-3.52 7.088-7.853V36.504c0-4.334-3.951-2.91-7.088-.563-6.896 5.172-26.22 19.551-33.834 25.214a5.244 5.244 0 0 1-6.273 0C33.403 55.528 14.367 41.33 7.088 35.917z'
          }),
          _react2.default.createElement('path', {
            fill: '#50D8BE',
            d: 'M7.088 77.078C3.927 78.778 0 81.412 0 84.573v.335c0 4.526 3.173 8.201 7.088 8.201H81.04c3.915 0 7.088-3.675 7.088-8.2v-.336c0-3.173-3.951-5.783-7.088-7.495-6.896-3.77-26.22-14.295-33.834-18.413a6.836 6.836 0 0 0-6.273 0c-7.531 4.094-26.567 14.474-33.846 18.413z'
          }),
          _react2.default.createElement('path', {
            fill: '#50D8BE',
            fillRule: 'nonzero',
            d: 'M64.124 71.823l4.49 2.466'
          }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            fillRule: 'nonzero',
            d: 'M68.614 75.426c-.2.001-.398-.048-.575-.143l-4.501-2.467a1.207 1.207 0 0 1 1.197-2.095l4.501 2.466a1.197 1.197 0 0 1-.622 2.24z',
            opacity: '.3'
          }),
          _react2.default.createElement(
            'g',
            { opacity: '.5' },
            _react2.default.createElement('path', {
              fill: '#50D8BE',
              d: 'M29.931 68.578l10.584-5.795a7.363 7.363 0 0 1 7.1 0l12.163 6.657'
            }),
            _react2.default.createElement('path', {
              fill: '#FFF',
              fillRule: 'nonzero',
              d: 'M59.778 70.637c-.2.001-.398-.048-.574-.143L47.04 63.837a6.166 6.166 0 0 0-5.987 0L30.47 69.632a1.207 1.207 0 1 1-1.197-2.096l10.583-5.794a8.548 8.548 0 0 1 8.25 0l12.163 6.656a1.197 1.197 0 0 1-.49 2.24z'
            })
          ),
          _react2.default.createElement('path', {
            fill: '#50D8BE',
            fillRule: 'nonzero',
            d: 'M20.245 73.882l5.196-2.85'
          }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            fillRule: 'nonzero',
            d: 'M20.245 75.079a1.197 1.197 0 0 1-.574-2.25l5.196-2.85a1.207 1.207 0 0 1 1.197 2.095l-5.196 2.85c-.19.107-.405.16-.623.155z',
            opacity: '.3'
          })
        )
      );
    }
  }]);

  return Mail;
}(_react2.default.PureComponent);

Mail.defaultProps = {
  size: 64
};

Mail.propTypes = {
  size: _propTypes2.default.number
};

exports.default = Mail;